export default {
  name: 'App',
  mounted() {}
};